// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2G60Y","approved":"Status_approved__zSRNQ","rejected":"Status_rejected__OhPu7","expired":"Status_expired__2SY5c","label":"Status_label__2tmIe"};